import React, { ChangeEvent } from 'react';
import classNames from 'classnames';

import styles from './main.scss';

type SwitchProps = {
    checked: boolean;
    children?: React.ReactNode;
    dataTn: string;
    label?: React.ReactNode;
    name?: string;
    onText?: React.ReactNode;
    offText?: React.ReactNode;
    onChange: (checked: boolean, e?: ChangeEvent<HTMLInputElement>) => void | null;
    value?: string | number;
};

type SwitchState = {
    checked: boolean;
};

export class Switch extends React.Component<SwitchProps, SwitchState> {
    static defaultProps = {
        onText: 'I',
        offText: 'O',
    };

    constructor(props: SwitchProps) {
        super(props);

        this.state = {
            checked: this.props.checked,
        };

        this.onChange = this.onChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps: SwitchProps): void {
        const { checked } = nextProps;

        /* istanbul ignore else */
        if (this.props.checked !== checked) {
            this.setState({ checked });
        }
    }

    onChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const { onChange } = this.props;
        const { checked } = e && e.currentTarget;

        /* istanbul ignore else */
        if (typeof checked === 'boolean') {
            this.setState({ checked });
            if (onChange) {
                onChange(checked, e);
            }
        }
    };

    render(): React.ReactNode {
        const { children, dataTn, label, name, onText, offText, value } = this.props;
        const { checked } = this.state;

        const switchClasses = classNames(styles.switch, {
            [styles.isChecked]: checked,
        });

        const sliderClasses = classNames(styles.slider, {
            [styles.isActive]: checked,
        });

        return (
            <div className={styles.wrapper}>
                {label && <div className={styles.label}>{label}</div>}
                <label htmlFor={name} className={switchClasses} data-tn={`${dataTn}-label`}>
                    <input
                        id={name}
                        name={name}
                        type={'checkbox'}
                        className={styles.hiddenInput}
                        checked={checked}
                        onChange={this.onChange}
                        value={value}
                        data-tn={`${dataTn}-input`}
                    />
                    <div className={styles.dot} />
                    <div className={sliderClasses}>
                        <div className={styles.sliderTextOn}>{onText}</div>
                        <div className={styles.sliderTextOff}>{offText}</div>
                    </div>
                </label>
                {children}
            </div>
        );
    }
}
